
Greenmile.Task = Greenmile.Task || {};

Greenmile.Task.SuggestedGeocoding = function (modelAttributes, locationSuggested, actualLocation) {

    Greenmile.Task.Suggested.apply(this, arguments);

    const taskId = modelAttributes.id;
    const classMainContainer = 'suggestedGeocoding'
    const classContainerToContent = `${classMainContainer}__containerToContent`;
    const classActualLatLongLabel = `${classMainContainer}__actualLatLong`;
    const classSuggestedLatLongLabel = `${classMainContainer}__suggestedLatLong`;
    const idMapContainer = 'suggestedGeocodingMap';
    const oldLocationIcon = 'images/map/markers/old-location.png';
    const newLocationIcon = 'images/map/markers/new-location.png';
    const hasPermissionToEditLocation = Monet.Security.checkKeyIsEnabled(['LOCATION_UPDATE']);
    const showActionButtons = hasPermissionToEditLocation;

    let map = null;

    const buildContainerMap = (containerMapAndButtons) => {
        const suggestedGeocodingMapContainer = document.createElement('div');
        suggestedGeocodingMapContainer.setAttribute('id', idMapContainer);
        containerMapAndButtons.appendChild(suggestedGeocodingMapContainer);
    };

    const buildLatLongLabel = (containerMapAndButtons) => {
        const latLongLabel = this.buildContainerToContent(`${classMainContainer}__latLongLabel`);
        const { latitude, longitude, stopLatitude, stopLongitude } = getDataToBuildMap();
        const actualLatLongToShow = { data : this.getResourceTo('Task.SuggestedGeocoding.actualLatlongNotProvided') };
        if(latitude && longitude) {
            actualLatLongToShow.data = `${latitude}, ${longitude}`;
        }

        const actualLatLongContainer = this.buildContainerToContent(classActualLatLongLabel);
        const suggestedLatLongContainer = this.buildContainerToContent(classSuggestedLatLongLabel);

        const actualLabel = this.getResourceTo('Task.SuggestedGeocoding.actualLatlongLabel');
        actualLatLongContainer.innerHTML = `${actualLabel}: ${actualLatLongToShow.data}`;

        const suggestedLabel = this.getResourceTo('Task.SuggestedGeocoding.suggestedLatlongLabel');
        suggestedLatLongContainer.innerHTML = `${suggestedLabel}: ${stopLatitude}, ${stopLongitude}`;

        latLongLabel.appendChild(actualLatLongContainer);
        latLongLabel.appendChild(suggestedLatLongContainer);
        containerMapAndButtons.appendChild(latLongLabel);
    };

    const showAllContent = (section, containerMapAndButtons) => {
        section.appendChild(containerMapAndButtons);
        map = App.Views.Task.renderMaps(idMapContainer, getDataToBuildMap());
    };

    const getDataToBuildMap = () => {
        const { latitude, longitude } = actualLocation;
        const { latitude: stopLatitude, longitude: stopLongitude } = locationSuggested;
        const popText = this.getResourceTo('Task.SuggestedGeocoding.markerPopText');

        return { latitude, longitude, stopLatitude, stopLongitude, locationIcon: newLocationIcon, popText, icon: oldLocationIcon };
    };

    const callbackAction = (typeAction) => {
        return () => {
            let latLong = {};
            let latLongLabelContainer = null;
            if(typeAction === this.pathActions.accept) {
                latLong = locationSuggested;
                latLongLabelContainer = document.querySelector(`.${classMainContainer} .${classActualLatLongLabel}`);
            } else if(typeAction === this.pathActions.decline) {
                latLong = actualLocation;
                latLongLabelContainer = document.querySelector(`.${classMainContainer} .${classSuggestedLatLongLabel}`);
            }

            latLongLabelContainer && latLongLabelContainer.classList.add("mutted");
            App.Views.Task.updateMarkers({ ...latLong, icon: newLocationIcon }, map);
        }
    };

    this.handleAlreadyDone = (typeAction) => {
        if (showActionButtons) {
          this.disableButtonsHandler();
        }

        if (modelAttributes.userChangeTaskFormStatus) {
          this.showWhoAndWhen(modelAttributes, classMainContainer, typeAction);
        }

        return callbackAction(typeAction);
    };

    this.disableButtonsHandler =  this.disableButtonsTo(classMainContainer);

    this.render = () => {
        const section = this.buildSection('Task.SuggestedGeocoding.title.section', classMainContainer);
        const containerMapAndButtons = this.buildContainerToContent(classContainerToContent);
        buildContainerMap(containerMapAndButtons);
        buildLatLongLabel(containerMapAndButtons);

        if (showActionButtons) {
          this.buildButtons(containerMapAndButtons, taskId);
        }

        showAllContent(section, containerMapAndButtons);
        this.checkSuggestionAlreadyDone(modelAttributes.taskFormStatus);
    };

    return this;
};
